module.exports = __webpack_public_path__ + "img/btn-bonus-code-redeem.d87bf27a.png";